import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Chrome extensions (e.g. Poper Blocker) inject scripts that throw SecurityError on
// localStorage; CRA's overlay treats that as an app crash. Ignore extension noise.
function isBrowserExtensionNoise(ev) {
  const msg = String(ev?.message || ev?.reason?.message || ev?.reason || "");
  const src = String(ev?.filename || ev?.error?.stack || ev?.reason?.stack || "");
  if (/chrome-extension:\/\/|moz-extension:\/\//i.test(src)) return true;
  if (/Failed to read the 'localStorage' property/i.test(msg) && /Access is denied/i.test(msg)) return true;
  return false;
}
window.addEventListener(
  "error",
  (ev) => {
    if (!isBrowserExtensionNoise(ev)) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
  },
  true,
);
window.addEventListener(
  "unhandledrejection",
  (ev) => {
    if (!isBrowserExtensionNoise(ev)) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
  },
  true,
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
